import React, { useMemo } from 'react';
import { COLORS } from '@ydistri/theme';
import { InfoIconTooltip } from '../../icons/InfoIconTooltip';
import { TbStarFilled } from 'react-icons/tb';

export interface ArchivedEntityListIconProps {
  content?: React.ReactNode;
  size?: number;
  color?: string;
}

/**
 * Icon indicating that the entity list is the default, with a tooltip.
 */
const DefaultEntityListIcon: React.FC<ArchivedEntityListIconProps> = ({
  content = 'Default entity list',
  size = 16,
  color = COLORS.PRIMARY,
}) => {
  const icon = useMemo(
    () => <TbStarFilled size={size} color={color} aria-hidden="true" />,
    [size, color],
  );

  return <InfoIconTooltip icon={icon} content={content} />;
};

export default DefaultEntityListIcon;
